import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { Container, Stack } from "@mui/material";

import { AccordianGrid, AccordionSet } from "../Components/AccordianGrid.jsx";
import { API_selectSubscriber } from "../App/api.jsx";
import { FtchPlusError, ftchPlus, getOptions, } from "../App/Account_urls.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { timeFormatter } from "../App/GridFormatters.jsx";
import { DeleteIconRenderer, EditIconRenderer, iconSize } from "../App/GridRenderers.jsx";

const SubscriberSelect = () => {
  const navigate = useNavigate();
  const icon = useRef();

  const gridRef_c = useRef(); // Optional - for accessing Grid's API
  const [subscribers, setSubscribers] = useState([]);
  const [errmsg, setErrmsg] = useState("")
  const [openAccordion, setOpenAccordion] = useState("0")



  //  consuming Grid Event
  const cellClickedListener = (event) => {

  }











  const avatarRenderer = (props) => {
    let avatar = "t";
    if (props.value) {
      let avatar = props.value;
    }
    console.log(avatar);
    //  return <img style="height: 14px; width: 14px" src={avatar} />;
    return (
      <div>
        <FontAwesomeIcon
          icon={faEdit}
          size={iconSize}
          //className="App-icon"
          color="light-blue"
        ></FontAwesomeIcon>
      </div>
    );
  };

  const ModuleIconRenderer = (props) => {
    return (
      <div>
        <FontAwesomeIcon
          icon={faEye}
          size={iconSize}
          //className="App-icon"
          color="light-blue"
        ></FontAwesomeIcon>
      </div>
    );
  };


  const columnDefName = {
    headerName: "Name",
    field: "FullName",
    width: 240,
    filter: "agTextColumnFilter",
    sort: "asc",
  };

  const columnDefProvince = {
    headerName: "Prov",
    field: "Province",
    width: 80,
  };
  const columnDefPicture = {
    headerName: "",
    field: "Picture",
    cellRenderer: avatarRenderer,
    width: 80,
  };

  const columnDefCreated = {
    headerName: "Created",
    field: "Created",
    valueFormatter: timeFormatter,
    width: 240,
  };
  const columnDefClientCount = {
    headerName: "Clients",
    type: "rightAligned",
    field: "ClientCount",
  };
  const columnDefScenarioCount = {
    headerName: "Scenarios",
    field: "ScenarioCount",
  };
  const columnDefClientSharedCount = {
    headerName: "Clients(Sh)",
    field: "ClientSharedCount",
  };
  const columnDefScenarioSharedCount = {
    headerName: "Scenarios(Sh)",
    field: "ScenarioSahredCount",
  };
  const columnDefLoginCount = {
    headerName: "Count",
    field: "LoginCount",
  };
  const columnDefLoginCountThisYear = {
    headerName: "This year",
    field: "LoginCountCurrentYear",
  };
  const columnDefLastLogin = {
    headerName: "Last",
    field: "LastLogin",
    valueFormatter: timeFormatter,
    width: 240,
  };
  const columnDefModules = {
    headerName: "Modules",
    field: "Modules",
    cellRenderer: ModuleIconRenderer,
  };
  const columnDefEdit = {
    headerName: "Edit",
    cellRenderer: EditIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70
  };

  const columnDefDelete = {
    headerName: "Delete",
    cellRenderer: DeleteIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    },
    width: 70

  };

  const columnDefsSubscribers = [
    // columnDefUse,
    columnDefName,
    // columnDefProvince,
    // columnDefPicture,
    columnDefCreated,
    columnDefClientCount,
    // columnDefScenarioCount,
    // {
    //   headerName: "Shared",
    //   children: [columnDefClientSharedCount, columnDefScenarioSharedCount],
    // },
    {
      headerName: "Logins",
      children: [
        columnDefLoginCount,
        // columnDefLoginCountThisYear,
        columnDefLastLogin,
      ],
    },
    // columnDefModules,
    // columnDefEdit,
    // columnDefDelete,
  ];

  const getData = async () => {
    console.log();
    var url = API_selectSubscriber;
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          console.log(json);
          setSubscribers(json.Subscribers);
        } else {
          console.log("no such data");
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };

  // load data from sever
  useEffect(() => {
    setErrmsg("")
    getData();
  }, []);

  const ready = () => {
    gridRef_c.current.api.sizeColumnsToFit();
  };

  const myAccordionOpen = (key, state) => {
    if (state) {
      setOpenAccordion(key)
    } else {
      setOpenAccordion("")
    }
  }

  const My_AccordianGrid = ({ ...otherProps }) => {
    return (
      <AccordianGrid
        cellClickedListener={cellClickedListener}
        onClick_kb={myAccordionOpen}
        openKey={openAccordion}
        {...otherProps}
      />
    )
  }

  return (
    <div style={{ display: "flex" }}>
      <Container maxWidth="true">
        <Stack spacing={1}>
          <AccordionSet >
            <My_AccordianGrid
              eventKey="0"
              name="Subscribers"
              columnDef={columnDefsSubscribers}
              data={subscribers}
            />
          </AccordionSet>
        </Stack>
        <ErrorBar error={errmsg} />
      </Container>
    </div>
  );
};

export default SubscriberSelect;
